// hooks/useBreadcrumb.js
import { useEffect } from "react";
import { useBreadcrumbStore } from "../store/useBreadcrumbStore";

export function useBreadcrumb(items, deps = [], options = {}) {
    const setBreadcrumb = useBreadcrumbStore((s) => s.setBreadcrumb);
    useEffect(() => {
        if (options.skip) return;
        setBreadcrumb(items); 
    }, deps); 
}